/* src/app/views/account/components/account/account.component.scss */
.button-container {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}
/*# sourceMappingURL=account.component.css.map */
